export default __webpack_public_path__ + "static/media/miscellaneous03.0fac5f0d.png";